const ANDES = 'Andes';
export const INIT_STACKUP_DATA = `${ANDES}/init_stackup_data`;
export const CHANGE_STACKUP_TABLE = `${ANDES}/change_stackup_table`;
export const SETTING_UNIT = `${ANDES}/setting_unit`;